import { $menuStore, $themeStore } from '@lib/store';
import { cn, PaletteUtils, RoutePaths } from '@shared/utils';
import { Button, Icon } from '@shared/widgets';
import { NavLink } from 'react-router-dom';
import ChevronIcon from '@assets/icons/chevron.svg';
import { useUnit } from 'effector-react';

interface HeaderProps {
  className?: string;
}

export const Header = (props: HeaderProps) => {
  const isCollapsedMenu = useUnit($menuStore.store);
  const isDarkTheme = useUnit($themeStore.store);

  return (
    <header className={cn('flex h-[70px] items-center justify-between py-4', isCollapsedMenu ? 'px-6' : 'px-8', props.className)}>
      <NavLink className='flex h-full items-center justify-center' to={RoutePaths.dashboard.onNavigate()}>
        {PaletteUtils.getLogo(isDarkTheme, isCollapsedMenu)}
      </NavLink>
      {!isCollapsedMenu && (
        <Button
          color='primary'
          className={cn(
            'h-8 w-8 rounded-sm p-0',
            'max-md:hidden',
            PaletteUtils.isVcfcPalette && 'rounded-3xl border border-ice dark:bg-obsidian-shade hover:dark:bg-obsidian-shade',
          )}
          onClick={() => $menuStore.events.toggleMenu()}
        >
          <Icon icon={<ChevronIcon />} color={PaletteUtils.getPaletteParam('secondary', 'white')} />
        </Button>
      )}
    </header>
  );
};
